var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Tvcaitaoxe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#E9EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9484 24.8868V23.1132C31.9484 22.8766 31.7448 22.6969 31.512 22.7164C31.4348 21.9875 31.2878 21.2804 31.0868 20.5961C31.3116 20.5266 31.4322 20.2807 31.3412 20.0609L30.6624 18.4224C30.5722 18.2045 30.3168 18.1166 30.1096 18.222C29.7619 17.5857 29.3556 16.9869 28.9031 16.4267C29.0843 16.2765 29.1017 16.0031 28.9334 15.8348L27.6793 14.5807C27.5111 14.4125 27.2375 14.4297 27.0873 14.611C26.5272 14.1585 25.9284 13.7522 25.2921 13.4045C25.3976 13.1973 25.3097 12.9419 25.0917 12.8517L23.4531 12.173C23.2334 12.082 22.9875 12.2026 22.918 12.4273C22.2338 12.2263 21.5265 12.0794 20.7977 12.0022C20.8075 11.8857 20.7691 11.7773 20.6958 11.6975C20.6891 11.69 20.679 11.6863 20.6716 11.6793C20.64 11.6495 20.6072 11.6207 20.567 11.6024C20.5168 11.5792 20.4608 11.5658 20.4008 11.5658H18.6273C18.5674 11.5658 18.5115 11.5792 18.4612 11.6024C18.4214 11.6205 18.3892 11.6491 18.3579 11.6783C18.3501 11.6856 18.3395 11.6895 18.3324 11.6975C18.2591 11.7773 18.2207 11.8857 18.2305 12.0021C17.5016 12.0792 16.7945 12.2263 16.1103 12.4273C16.0407 12.2026 15.7948 12.0819 15.5751 12.1729L13.9365 12.8516C13.7186 12.9419 13.6307 13.1972 13.7361 13.4044C13.0999 13.7521 12.5011 14.1584 11.9409 14.6109C11.7907 14.4297 11.5171 14.4124 11.3489 14.5806L10.0948 15.8347C9.92658 16.0029 9.94386 16.2765 10.1252 16.4267C9.67271 16.9868 9.26641 17.5856 8.91865 18.2219C8.71143 18.1165 8.45605 18.2044 8.36583 18.4223L7.68709 20.0609C7.59608 20.2806 7.71668 20.5266 7.94147 20.596C7.74044 21.2803 7.59349 21.9874 7.51631 22.7162C7.28353 22.6969 7.07999 22.8766 7.07999 23.1132V24.8868C7.07999 25.1235 7.28353 25.3033 7.51638 25.2836C7.59349 26.0124 7.74051 26.7196 7.94154 27.4039C7.71683 27.4734 7.59615 27.7193 7.68716 27.939L8.36591 29.5776C8.45612 29.7955 8.71143 29.8834 8.91872 29.778C9.26641 30.4142 9.67278 31.0131 10.1252 31.5732C9.94407 31.7234 9.92665 31.9969 10.0949 32.1651L11.3491 33.4193C11.5173 33.5875 11.7908 33.5701 11.941 33.389C12.5012 33.8414 13.1 34.2477 13.7362 34.5955C13.6308 34.8026 13.7187 35.058 13.9366 35.1482L15.5753 35.827C15.8397 35.9365 15.9945 35.8143 16.1046 35.5712C16.7906 35.7731 17.4998 35.9205 18.2306 35.9978C18.2208 36.1142 18.2593 36.2226 18.3325 36.3023C18.3396 36.3103 18.3503 36.3142 18.358 36.3216C18.3894 36.3508 18.4216 36.3794 18.4613 36.3974C18.5116 36.4206 18.5676 36.434 18.6275 36.434H20.4011C20.461 36.434 20.517 36.4206 20.5673 36.3974C20.6075 36.3791 20.6403 36.3503 20.6719 36.3205C20.6793 36.3136 20.6894 36.3099 20.6961 36.3023C20.7693 36.2226 20.8078 36.1142 20.798 35.9977C21.5269 35.9206 22.234 35.7736 22.9183 35.5725C22.9878 35.7973 23.2336 35.9179 23.4534 35.8268L25.0921 35.1481C25.31 35.0579 25.3979 34.8025 25.2925 34.5954C25.9287 34.2476 26.5275 33.8413 27.0877 33.3889C27.2379 33.57 27.5114 33.5874 27.6796 33.4192L28.9338 32.165C29.102 31.9968 29.0846 31.7233 28.9035 31.5731C29.3559 31.0129 29.7622 30.4141 30.11 29.7778C30.3172 29.8833 30.5726 29.7954 30.6628 29.5775L31.3415 27.9389C31.4325 27.7191 31.3119 27.4732 31.0872 27.4037C31.2882 26.7195 31.4352 26.0122 31.5123 25.2835C31.7448 25.3033 31.9484 25.1235 31.9484 24.8868ZM19.5142 32.7572C14.6777 32.7572 10.757 28.8365 10.757 24C10.757 19.1635 14.6777 15.2428 19.5142 15.2428C24.3506 15.2428 28.2713 19.1635 28.2713 24C28.2713 28.8365 24.3506 32.7572 19.5142 32.7572Z",
    fill: "url(#paint0_linear_735_3062)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0567 19.9829H19.9699C20.2106 19.9829 20.4179 19.8157 20.4647 19.5817L20.7723 18.0305C20.8391 17.7162 20.5984 17.4287 20.2842 17.4287H18.749C18.4281 17.4287 18.194 17.7163 18.2542 18.0305L18.5685 19.5817C18.6154 19.8157 18.8227 19.9829 19.0567 19.9829Z",
    fill: "url(#paint1_linear_735_3062)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9698 28.0172H19.0566C18.8226 28.0172 18.6153 28.1844 18.5685 28.4185L18.2542 29.9696C18.194 30.2839 18.4281 30.5714 18.749 30.5714H20.2841C20.5984 30.5714 20.8391 30.2838 20.7722 29.9696L20.4646 28.4185C20.4178 28.1843 20.2105 28.0172 19.9698 28.0172Z",
    fill: "url(#paint2_linear_735_3062)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6769 21.4818C22.8471 21.652 23.1118 21.6804 23.3104 21.5479L24.6248 20.6686C24.8943 20.4936 24.9274 20.1201 24.7051 19.8979L23.6197 18.8124C23.3927 18.5855 23.0239 18.6234 22.8442 18.8881L21.9696 20.2072C21.8372 20.4057 21.8656 20.6706 22.031 20.836L22.6769 21.4818Z",
    fill: "url(#paint3_linear_735_3062)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3501 26.517C16.1846 26.3515 15.9199 26.3232 15.7213 26.4556L14.4022 27.3302C14.1375 27.5099 14.0996 27.8787 14.3265 28.1056L15.412 29.1911C15.6343 29.4134 16.0078 29.3803 16.1827 29.1108L17.062 27.7964C17.1945 27.5978 17.1661 27.333 16.9959 27.1629L16.3501 26.517Z",
    fill: "url(#paint4_linear_735_3062)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9325 23.0545C23.6984 23.1013 23.5312 23.3085 23.5312 23.5425V24.4558C23.5312 24.6965 23.6984 24.9038 23.9325 24.9506L25.4837 25.2582C25.798 25.325 26.0854 25.0843 26.0854 24.77V23.235C26.0854 22.9141 25.798 22.68 25.4837 22.7402L23.9325 23.0545Z",
    fill: "url(#paint5_linear_735_3062)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.497 24.4558V23.5425C15.497 23.3085 15.3299 23.1013 15.0958 23.0545L13.5446 22.7402C13.2304 22.68 12.9429 22.9141 12.9429 23.235V24.77C12.9429 25.0843 13.2304 25.325 13.5446 25.2582L15.0958 24.9506C15.3299 24.9038 15.497 24.6965 15.497 24.4558Z",
    fill: "url(#paint6_linear_735_3062)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.307 26.4556C23.1084 26.3232 22.8436 26.3515 22.6781 26.517L22.0324 27.1627C21.8621 27.333 21.8338 27.5977 21.9662 27.7963L22.8456 29.1106C23.0206 29.3801 23.394 29.4132 23.6163 29.191L24.7018 28.1055C24.9287 27.8786 24.8908 27.5099 24.6261 27.3301L23.307 26.4556Z",
    fill: "url(#paint7_linear_735_3062)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7177 21.5479C15.9163 21.6804 16.1811 21.652 16.3513 21.4818L16.997 20.836C17.1625 20.6706 17.1909 20.4058 17.0585 20.2072L16.1838 18.8881C16.0041 18.6234 15.6354 18.5855 15.4084 18.8124L14.323 19.8979C14.1007 20.1202 14.1338 20.4936 14.4033 20.6686L15.7177 21.5479Z",
    fill: "url(#paint8_linear_735_3062)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5142 20.7485C17.7185 20.7485 16.2628 22.2043 16.2628 24C16.2628 25.7957 17.7185 27.2514 19.5142 27.2514C21.3098 27.2514 22.7655 25.7957 22.7655 24C22.7655 22.2043 21.3098 20.7485 19.5142 20.7485ZM18.7695 21.7729C19.1931 21.4999 19.8338 21.4992 20.2589 21.7729C20.4286 21.882 20.4774 22.1075 20.3683 22.2771C20.2593 22.4467 20.0337 22.4952 19.8641 22.3865C19.6809 22.2692 19.3474 22.2692 19.1642 22.3865C18.9944 22.4958 18.7691 22.4462 18.66 22.2771C18.5509 22.1078 18.5998 21.882 18.7695 21.7729ZM17.9006 24.3498C18.0093 24.5194 17.9608 24.745 17.7913 24.854C17.6216 24.9631 17.3961 24.9142 17.2871 24.7447C17.0134 24.3195 17.0141 23.6789 17.2871 23.2552C17.3961 23.0857 17.622 23.0368 17.7913 23.1458C17.9607 23.2551 18.0097 23.4805 17.9006 23.6501C17.7834 23.8332 17.7834 24.1667 17.9006 24.3498ZM20.2589 26.2271C19.8338 26.5008 19.1931 26.5 18.7694 26.2271C18.5998 26.1181 18.5509 25.8921 18.66 25.7229C18.769 25.5537 18.9943 25.5043 19.1642 25.6135C19.3473 25.7307 19.6808 25.7307 19.864 25.6135C20.0336 25.5049 20.2591 25.5533 20.3682 25.7229C20.4773 25.8925 20.4285 26.1181 20.2589 26.2271ZM19.5142 25.0946C18.9096 25.0946 18.4195 24.6045 18.4195 24C18.4195 23.3955 18.9097 22.9054 19.5142 22.9054C20.1187 22.9054 20.6088 23.3954 20.6088 24C20.6088 24.6046 20.1187 25.0946 19.5142 25.0946ZM21.7413 24.7448C21.6323 24.9143 21.4067 24.9631 21.2371 24.8541C21.0675 24.745 21.019 24.5195 21.1277 24.3499C21.2449 24.1667 21.2449 23.8332 21.1277 23.6501C21.0185 23.4802 21.0679 23.2549 21.2371 23.1458C21.4063 23.0368 21.6323 23.0856 21.7413 23.2552C22.0141 23.6789 22.0149 24.3196 21.7413 24.7448Z",
    fill: "url(#paint9_linear_735_3062)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1721 18.95C37.2513 18.95 37.3305 18.9572 37.4025 18.9644V17.798C37.4025 17.654 37.2873 17.5316 37.1361 17.5316L37.1356 16.0527H37.4018V15.2945H37.0751V14.5364H35.5088V15.2945H35.1821V16.0527H35.4482V17.5316H35.4441C35.3001 17.5316 35.1777 17.654 35.1777 17.798V18.9644C35.2497 18.9572 35.3289 18.95 35.4081 18.95L37.1721 18.95Z",
    fill: "url(#paint10_linear_735_3062)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1618 34.7283H32.4202C32.0032 34.7283 31.6621 35.0695 31.6621 35.4864V35.676C31.6621 36.093 32.0033 36.4342 32.4202 36.4342H40.1618C40.5788 36.4342 40.92 36.093 40.92 35.676V35.4864C40.92 35.0695 40.5788 34.7283 40.1618 34.7283Z",
    fill: "url(#paint11_linear_735_3062)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2628 26.7692H39.3252V33.6452H33.2628V26.7692Z",
    fill: "url(#paint12_linear_735_3062)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6679 25.1222C38.6679 24.7051 38.3267 24.364 37.9097 24.364H34.6799C34.2553 24.364 33.9217 24.7051 33.9217 25.1222V25.6908H38.6679V25.1222Z",
    fill: "url(#paint13_linear_735_3062)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9354 20.7859C37.9354 20.3611 37.5898 20.0299 37.1722 20.0299H35.4082C34.9906 20.0299 34.6522 20.3611 34.6522 20.7859V23.2843H37.9354V20.7859Z",
    fill: "url(#paint14_linear_735_3062)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_735_3062",
    x1: 7.07999,
    y1: 22.1348,
    x2: 31.9484,
    y2: 22.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_735_3062",
    x1: 18.2448,
    y1: 18.5142,
    x2: 20.7835,
    y2: 18.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_735_3062",
    x1: 18.2448,
    y1: 29.1027,
    x2: 20.7834,
    y2: 29.1027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_735_3062",
    x1: 21.8861,
    y1: 19.9247,
    x2: 24.8518,
    y2: 19.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_735_3062",
    x1: 14.1776,
    y1: 27.6325,
    x2: 17.1452,
    y2: 27.6325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_735_3062",
    x1: 23.5313,
    y1: 23.8096,
    x2: 26.0854,
    y2: 23.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_735_3062",
    x1: 12.9429,
    y1: 23.8096,
    x2: 15.497,
    y2: 23.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_735_3062",
    x1: 21.883,
    y1: 27.6324,
    x2: 24.8507,
    y2: 27.6324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_735_3062",
    x1: 14.1763,
    y1: 19.9247,
    x2: 17.142,
    y2: 19.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_735_3062",
    x1: 16.2628,
    y1: 23.5123,
    x2: 22.7655,
    y2: 23.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_735_3062",
    x1: 36.2901,
    y1: 14.5364,
    x2: 36.2901,
    y2: 18.9644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_735_3062",
    x1: 36.291,
    y1: 34.7283,
    x2: 36.291,
    y2: 36.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_735_3062",
    x1: 36.294,
    y1: 26.7692,
    x2: 36.294,
    y2: 33.6452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_735_3062",
    x1: 36.2948,
    y1: 24.364,
    x2: 36.2948,
    y2: 25.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_735_3062",
    x1: 36.2938,
    y1: 20.0299,
    x2: 36.2938,
    y2: 23.2843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Tvcaitaoxe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2tvcaitaoxe.e2efe472.svg";
export { ForwardRef as ReactComponent };